import axios from  'axios'

const api = axios.create({
  baseURL: "https://bethehero-back.herokuapp.com/"
})

export default api